import Header from "../Header/Header";
import React, { Suspense, lazy } from "react";
import Navigation from "../Sidebar/Navigation";
import { Routes, Route } from "react-router-dom";

// Lazy load components for better performance
const HomePage = lazy(() => import("../../Pages/Home/Home"));

// Loading component
const LoadingSpinner = () => (
  <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-[#000000] z-50">
    <div className="w-10 h-10 border-3 border-white/10 border-t-[#22d4fd] rounded-full animate-spin shadow-[0_0_15px_rgba(34,212,253,0.25)]"></div>
    <p className="mt-4 text-[#22d4fd] text-xs font-semibold tracking-widest uppercase">Loading Portfolio...</p>
  </div>
);

const Layout = React.memo(() => {
  return (
    <div className="lg:flex md:flex block lg:container md:px-4 px-2 mx-auto h-screen overflow-hidden">
      {/* Desktop/Tablet Navigation Sidebar */}
      <div className="lg:w-[20%] md:w-[20%] lg:block md:block hidden text-white z-30">
        <Navigation />
      </div>

      {/* Main Content Area */}
      <div className="lg:flex-1 md:flex-1 w-full flex flex-col overflow-hidden">
        <header className="fixed top-0 left-0 right-0 z-20 bg-[#000000]">
          <Header />
        </header>

        <main className="flex-1 2xl:mt-16 xl:mt-14 lg:mt-16 md:mt-16 mt-16 lg:p-4 md:p-4 p-0">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </Suspense>
        </main>
      </div>

      {/* Mobile Navigation - Bottom Fixed */}
      <div className="lg:hidden md:hidden block">
        <Navigation />
      </div>
    </div>
  );
});

Layout.displayName = "Layout";

export default Layout;
